import { render } from "./ModalInbound.vue?vue&type=template&id=9093ded2"
import script from "./ModalInbound.vue?vue&type=script&lang=js"
export * from "./ModalInbound.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__